import { render } from "./LoginFaceForm.vue?vue&type=template&id=3546c9c7&ts=true"
import script from "./LoginFaceForm.vue?vue&type=script&lang=ts"
export * from "./LoginFaceForm.vue?vue&type=script&lang=ts"

import "./LoginFaceForm.vue?vue&type=style&index=0&id=3546c9c7&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__